import { Injectable } from '@angular/core';
import { Api } from '../../contracts/classes/api.class';
import { Observable } from 'rxjs';
import { IResponse } from '../../contracts/models/response.model';
import { CreateTypeSocialMediaDTO, TypeSocialMedia, updateOrderTypeSocialMediaDTO, UpdateTypeSocialMediaDTO } from '../../contracts/models/type-social-media.model';

@Injectable({
  providedIn: 'root'
})
export class TypeSocialMediaService extends Api {

  getAll(): Observable<IResponse<TypeSocialMedia[]>> {
    return this.http.get<IResponse<TypeSocialMedia[]>>(`${this.url}/tipoRedSocial`);
  }

  create(createTypeEmailDTO: CreateTypeSocialMediaDTO): Observable<IResponse<TypeSocialMedia>> {
    return this.http.post<IResponse<TypeSocialMedia>>(`${this.url}/tipoRedSocial`, createTypeEmailDTO);
  }

  update(UpdateTypeSocialMediaDTO: UpdateTypeSocialMediaDTO): Observable<IResponse<TypeSocialMedia>> {
    return this.http.put<IResponse<TypeSocialMedia>>(`${this.url}/tipoRedSocial/${UpdateTypeSocialMediaDTO.id}`, UpdateTypeSocialMediaDTO);
  }

  delete(id: number): Observable<IResponse<TypeSocialMedia>> {
    return this.http.delete<IResponse<TypeSocialMedia>>(`${this.url}/tipoRedSocial/${id}`);
  }

  updateOrder(updateOrderTypeSocialMediaDTO: updateOrderTypeSocialMediaDTO[]): Observable<IResponse<TypeSocialMedia[]>> {
    return this.http.put<IResponse<TypeSocialMedia[]>>(`${this.url}/tipoRedSocial/data/updateOrder`, {
      tipoRedesSociales: updateOrderTypeSocialMediaDTO
    });
  }
}
